export const updateCartInDatabase = async (cartItems, userId) => {
    const response = await fetch(process.env.REACT_APP_UPDATE_CART_URL, {
      method: "POST",
      body: JSON.stringify({ userId, cartItems }),
      headers: {
        "content-type": "application/json",
      },
    });
  
    return response;
  };